import { ActionType } from "./Actions";
import fakeAuthReducer from "./Reducers/Auth/fakeReducer";
import initTokenReducer from "./Reducers/Auth/initTokenReducer";
import deviceCodeReducer from "./Reducers/Auth/deviceCodeReducer";
import deviceTokenReducer from "./Reducers/Auth/deviceTokenReducer";
import parametersOpeningReducer from "./Reducers/Auth/parametersOpeningReducer";

const combineReducers = (slices: any) => (state: AuthStateType, action: ActionType) =>
Object.keys(slices).reduce( // use for..in loop, if you prefer it
(acc, prop) => ({
    ...acc,
    // @ts-ignore
    ...slices[prop](acc[prop], action),
}),
state
);

export type AuthStateType = {
    user : object | null;
    token: string | null;
    deviceCodeResult?: {
        deviceCode: string,
        userCode: string,
        verificationUri: string,
        verificationUriComplete: string,
        expiresIn: number,
        interval: number
     } | null;
    tokens?: {
        identityToken: string,
        accessToken:string,
        refreshToken:string,
        expiresIn: number
    } | null;
    canOpenParametersUntil?: Date
  }

export const InitialState: AuthStateType = {
    user: null,
    token: null,
}

export const Reducer = combineReducers({
    fakeAuthReducer,
    initTokenReducer,
    deviceCodeReducer,
    deviceTokenReducer,
    parametersOpeningReducer
});
